export default {
  title: 'Notifications par défaut',
  subtitle:
    "Ce que reçoivent, sans avoir rien choisi, les personnes à qui chaque notification est destinée. Le choix de chaque membre l'emporte toujours, et ces réglages ne concernent personne d'autre.",
  loadFailed: "Les réglages par défaut n'ont pas pu être chargés.",
  audience: 'Destinataires par défaut : {audience}.',
  audiences: {
    administrators: "les administrateurs de l'organisation",
    reviewers: "les personnes qui examinent les demandes d'inscription",
    holders: 'les membres dont le rôle détient « {permission} »',
    workspaceSeat: "les membres de l'espace concerné",
    workspaceReader: "les personnes qui consultent l'espace concerné",
    moderators: "les personnes qui modèrent l'espace concerné",
    workspaceHolders: "les membres dont le rôle dans l'espace concerné détient « {permission} »",
    sellers: 'les personnes qui gèrent les ventes des chaînes',
    websiteOperator: 'le propriétaire de la chaîne concernée',
  },
  audienceSeparator: ' et ',
  roles: "Rôles concernés aujourd'hui : {roles}",
  noRoles: "Aucun rôle de l'organisation n'en fait partie aujourd'hui.",
  platformDefault: 'Défaut de la plateforme : {value}',
  choices: {
    label: "Choix de l'organisation",
    platform: 'Défaut',
    on: 'Activé',
    off: 'Désactivé',
  },
  values: {
    on: 'activé',
    off: 'désactivé',
  },
  result: {
    on: 'Reçue par les personnes à qui elle est destinée, sauf celles qui la désactivent.',
    off: "Reçue seulement par les personnes qui l'activent elles-mêmes.",
  },
  refusals: {
    mandatory: 'Cette notification est obligatoire par e-mail : elle ne peut pas être désactivée.',
    notSelectable: "Ce canal n'est pas encore disponible.",
    failed: "Le changement n'a pas pu être enregistré.",
  },
}
